<template>
  <div class="EditBandLyrics">
    <MainPageHeader v-if="!isAndroidContext"/>
    <PageNotFound v-if="loadError" :message="loadError"/>
    <LoaderLyrics v-if="!bandLyric.id"
        :title="'Edytujesz piosenkę'"/>
    <BandLyricForm
        :isAndroidContext="isAndroidContext"
        v-else
        :bandLyric="bandLyric"
        :saving="saving"
        :isEditingMode="isEditingMode"
        :previousLyric="previousLyric"
        :nextLyric="nextLyric"
        :loadingNewPage="loadingNewPage"
        :askPopup="isAskPopup"
        :loadingImage="loadingImage"
        pageTitle="Edytujesz piosenkę"
        ref="BandLyricForm"
        @handleAskPopup="handleAskPopup"
        @changeLyricPage="handleLyricChangePage"
        @change="handleBandLyricChange"
        @save="handleSave"
        @loadImage="handleLoadImage"
        @setLoading="setLoading"
    />
    <Footer v-if="!isAndroidContext"/>
  </div>
</template>

<script>
import MainPageHeader from '@/components/MainPageHeader.vue'
import { getBandLyricsService } from '../services/bandLyricsService'
import PageNotFound from '@/components/PageNotFound.vue'
import BandLyricForm from '@/components/lyrics/BandLyricForm.vue'
import Footer from '@/components/Footer'
import LoaderLyrics from '@/components/lyrics/LoaderLyrics.vue'
import { getAndroidContext } from '@/services/sessionProps'
import { getLyricsService } from '@/services/lyricsService'

export default {
  name: 'EditBandLyricPage',
  components: {
    Footer,
    MainPageHeader,
    PageNotFound,
    BandLyricForm,
    LoaderLyrics,
  },

  props: {
    allLyrics: {
      required: false,
    },
    id: {
      required: false,
    },
    search: {
      type: Boolean,
      required: false
    }
  },

  data () {
    return {
      bandLyric: {
        previousLyric: {},
        nextLyric: {}
      },
      loadError: null,
      saving: false,
      isEditingMode: true,
      isAndroidContext: false,
      previousLyric: {},
      nextLyric: {},
      indexOfLyricElement: null,
      refreshAllLyrics: this.allLyrics,
      refreshId: this.id,
      pageOfLyrics: 1,
      lastPageOfLyricsAPI: 0,
      loadingNewPage: false,
      isAskPopup: false,
      loadingImage: true,
    }
  },

  methods: {
    setLoading () {
      this.saving = true
    },
    handleLoadImage(event){
      this.loadingImage = event
    },
    handleBandLyricChange (updatedFields) {
      this.bandLyric = {
        ...this.bandLyric,
        ...updatedFields,
      }
    },
    handleAskPopup (state) {
      this.isAskPopup = state
    },
    async handleSave (bandLyric, direction) {
      this.saving = true
      let order = 0

      let saveLyric = {
        band: bandLyric.band,
        content: bandLyric.content,
        id: bandLyric.id,
        images: bandLyric.images,
        playlistItems: bandLyric.playlistItems,
        title: bandLyric.title,
        duration: bandLyric.duration,
        lyricTags: bandLyric.lyricTags
      }

      try {
        await getBandLyricsService().modifyBandLyric(saveLyric)

        for (const image of this.bandLyric.images) {
          if (image.substring(0, 10) === 'data:image') {
            let imageResource = await getBandLyricsService()
                .createBandLyricPicture(bandLyric.id, image, order)
            if(imageResource === null)
              this.$root.showSnackbar("Błąd podczas przesyłania obrazka", "error")
          }
          order++
        }

        if(direction===-1 || direction===1) {
          this.refreshAllLyrics = await getLyricsService().getBandLyrics(1)
          this.refreshId = parseInt(this.$route.params.id)
          this.lastPageOfLyricsAPI = this.refreshAllLyrics.lastPage.page

          for (let i = 2; i <= this.lastPageOfLyricsAPI; i++) {
            let newLyrics = await getLyricsService().getBandLyrics(i)

            newLyrics.bandLyrics.map(lyric => {
              this.refreshAllLyrics.bandLyrics.push(lyric)
            })

            }
            this.refreshAllLyrics.bandLyrics.map((lyric, index) => {
              if (lyric.id===this.refreshId) {
                this.bandLyric = lyric
                this.indexOfLyricElement = index
              }
            })
          this.handleLyricChangePage(direction)
          this.isAskPopup = false
        } else {
          this.$router.push('/lyrics')
          this.isAskPopup = false
        }

      } catch (err) {
        console.error('[SHOW NOTIFY] DATA NOT SAVED')
        this.$root.showSnackbar("Błąd podczas przesyłania piosenki", "error")
        this.isAskPopup = false
      }

      this.saving = false
    },
    async handleLyricChangePage (direction) {
      if(direction<0 && this.indexOfLyricElement!==0) {
        this.indexOfLyricElement = this.indexOfLyricElement - 1
        this.changeLyrics()
      } else if (direction>0 && this.indexOfLyricElement!==this.refreshAllLyrics.bandLyrics.length-1) {
        this.indexOfLyricElement = this.indexOfLyricElement + 1
        this.changeLyrics()
      }

      if(this.indexOfLyricElement===this.refreshAllLyrics.bandLyrics.length-2 &&
          this.indexOfLyricElement!==this.refreshAllLyrics.totalItems-2) {
        this.loadingNewPage = true
        this.pageOfLyrics = this.pageOfLyrics + 1
        const newLyrics = await getLyricsService().getBandLyrics(this.pageOfLyrics)


        if(newLyrics) {
          newLyrics.bandLyrics.forEach(lyric => {
            this.refreshAllLyrics.bandLyrics.push(lyric)
          })
          this.loadingNewPage=false
        }
      }
    },
    changeLyrics () {
      this.refreshAllLyrics.bandLyrics.map((lyric, index) => {
        if (index===this.indexOfLyricElement) {
          this.bandLyric = lyric
            this.$router.push({ name: 'EditBandLyricPage', params: { id: lyric.id, allLyrics: this.refreshAllLyrics} })
          }
      })

      this.getLyricsPagination()
    },
    getLyricsPagination () {
      if (this.indexOfLyricElement!==0) {
        this.bandLyric.previousLyric = JSON.parse(JSON.stringify
        (this.refreshAllLyrics.bandLyrics[this.indexOfLyricElement-1]))
        if (this.bandLyric.previousLyric.title.length>22) {
          this.bandLyric.previousLyric.title = this.cutLyricTitle(this.bandLyric.previousLyric.title)
        }
      }

      if(this.indexOfLyricElement!==this.refreshAllLyrics.bandLyrics.length-1) {
        this.bandLyric.nextLyric = JSON.parse(JSON.stringify
        (this.refreshAllLyrics.bandLyrics[this.indexOfLyricElement+1]))
        if (this.bandLyric.nextLyric.title.length>22) {
          this.bandLyric.nextLyric.title = this.cutLyricTitle(this.bandLyric.nextLyric.title)
        }
      }
    },
    cutLyricTitle (title) {
      return title.slice(0,22) + '...'
    }
  },

  mounted () {
    window.scrollTo(0,0);
    (async () => {
      this.isAndroidContext = getAndroidContext().isAndroidContext()
      try {
        if (!this.allLyrics || this.search===true) {
          this.refreshAllLyrics = await getLyricsService().getBandLyrics(1)
          this.refreshId = parseInt(this.$route.params.id)
          this.lastPageOfLyricsAPI = this.refreshAllLyrics.lastPage.page

          for (let i = 2; i <= this.lastPageOfLyricsAPI; i++) {
            let newLyrics = await getLyricsService().getBandLyrics(i)
            newLyrics.bandLyrics.map(lyric => {
              this.refreshAllLyrics.bandLyrics.push(lyric)
            })

            }
            this.refreshAllLyrics.bandLyrics.map((lyric, index) => {
            if (lyric.id===this.refreshId) {
              this.bandLyric = lyric
              this.indexOfLyricElement = index
            }
          })
        } else {
          this.refreshAllLyrics.bandLyrics.map((lyric, index) => {
            if (lyric.id===this.id) {
              this.bandLyric = lyric
              this.indexOfLyricElement = index
            }
          })
        }

        this.getLyricsPagination()
      } catch (err) {
        this.loadError = `The bandLyric with the specified id doesn't exist`
      }
    })()
  },
}
</script>

<style lang="scss" scoped>

.EditBandLyrics {
  position: relative;
  padding-bottom: 20px;
  min-height: calc(100vh - 278px);
}

</style>
